<template>
  <div>
    <!-- 搜索条件 -->
    <el-form :inline="true" :model="searchForm" size="small" @keyup.enter.native="getDataList()">
      <el-form-item label="公司代码">
        <el-input v-model="searchForm.searchOrgCode" placeholder="公司代码" clearable style="width: 150px" />
      </el-form-item>
      <el-form-item label="公司名称">
        <el-input v-model="searchForm.searchOrgName" placeholder="公司名称" clearable style="width: 150px" />
      </el-form-item>
      <el-form-item label="订单类型">
        <el-select v-model="searchForm.searchOrderType" placeholder="订单类型" clearable style="width: 150px">
          <el-option v-for="item in purchaseTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getDataList()" icon="el-icon-search">查询</el-button>
      </el-form-item>
    </el-form>

    <el-button
        size="mini"
        type="primary"
        @click="handleAdd()"
        style="margin-bottom: 20px"
    >新增</el-button>

    <div v-loading="dataListLoading">
      <el-table ref="tableForm" :data="dataList" row-key="id" size="mini" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
        <el-table-column type="index" width="50" label="序号">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="orgCode" header-align="center" align="center" label="公司代码" min-width="100">
        </el-table-column>
        <el-table-column prop="orgName" header-align="center" align="center" label="公司名称" min-width="250">
        </el-table-column>
        <el-table-column prop="paperOri" header-align="center" align="center" label="模板类型" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.paperOri === 0 ? 'A4-器具' : scope.row.paperOri === 1 ? '二等分' : scope.row.paperOri === 2 ? '一件代发' : scope.row.paperOri === 3 ? 'A4' : 'A4-器具' }}
          </template>
        </el-table-column>
        <el-table-column prop="orderType" header-align="center" align="center" label="订单类型" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.orderTypeName || scope.row.orderType || '默认配置' }}
          </template>
        </el-table-column>
        <el-table-column prop="logoPng" header-align="center" align="center" label="公司LOGO" min-width="150">
          <template slot-scope="scope">
            <el-button
                type="text"
                size="mini"
                @click="viewLogo(scope.row.logoPng)"
                v-if="scope.row.logoPng"
            >查看</el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="160">
          <template slot-scope="{row}">
            <el-button type="text" size="mini" @click="handleEdit(row)">修改</el-button>
            <el-button type="text" size="mini" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 新增/修改对话框 -->
      <el-dialog :title="dialogMode === 'add' ? '新增交货单打印设置' : '修改交货单打印设置'" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
        <el-form :model="addForm" :rules="addRules" ref="addForm" label-width="120px">
          <el-form-item label="子公司：" prop="subcompany">
            <el-row>
              <el-col :span="20">
                <el-input
                    v-model="addForm.subcompany.name"
                    readonly
                    :disabled="dialogMode === 'edit'"
                    placeholder="请选择子公司"
                ></el-input>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="openSubcompanyDialog" :disabled="dialogMode === 'edit'">搜索</el-button>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="模板类型：" prop="paperOri">
            <el-radio-group v-model="addForm.paperOri">
              <el-radio :label="0">A4-器具</el-radio>
              <el-radio :label="1">二等分</el-radio>
              <el-radio :label="2">一件代发</el-radio>
              <el-radio :label="3">A4</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="订单类型：" prop="orderType">
            <el-select v-model="addForm.orderType" placeholder="不选则为默认配置" clearable style="width: 100%;">
              <el-option
                v-for="item in purchaseTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="公司LOGO：" prop="logoPng">
            <!-- 编辑模式下显示现有LOGO预览 -->
            <div v-if="dialogMode === 'edit' && existingLogoPreview" style="margin-bottom: 10px;">
              <img :src="existingLogoPreview" style="max-width: 200px; max-height: 100px; border: 1px solid #ddd;" />
              <el-button size="mini" type="text" @click="removeExistingLogo" style="margin-left: 10px;">删除现有LOGO</el-button>
            </div>
            <el-upload
                action=""
                :auto-upload="false"
                :on-change="handleFileChange"
                :file-list="fileList"
                accept=".png,.jpg,.jpeg"
                :limit="1"
                :on-exceed="handleExceed"
                :show-file-list="true"
                :on-remove="handleRemove"
                class="upload-demo"
            >
              <el-button size="small" type="primary">选择文件</el-button>
              <div slot="tip" class="el-upload__tip">
                只能上传PNG/JPG/JPEG格式文件
                <span v-if="addForm.logoPng && addForm.logoPng.length > 0" style="color: green;">
              （已选择文件，大小: {{ Math.round(addForm.logoPng.length / 1024) }}KB）
          </span>
                <span v-else-if="dialogMode === 'edit' && existingLogoPreview" style="color: #999;">
              （未选择新文件将保留现有LOGO）
          </span>
                <span v-else style="color: #999;">
              （未选择文件）
          </span>
              </div>
            </el-upload>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAdd">保 存</el-button>
      </span>
      </el-dialog>

      <!-- 子公司搜索帮助对话框 -->
      <el-dialog title="选择子公司" :visible.sync="subcompanyDialogVisible" width="800px">
        <el-input v-model="subcompanyFilter" placeholder="请输入子公司名称或代码" style="margin-bottom: 10px;"></el-input>
        <el-table
            :data="filteredSubcompanies"
            highlight-current-row
            @current-change="handleSubcompanySelect"
            height="300"
        >
          <el-table-column prop="orgCode" label="子公司代码" width="150"></el-table-column>
          <el-table-column prop="orgName" label="子公司名称"></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
        <el-button @click="subcompanyDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmSubcompany">确 定</el-button>
      </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {getSubcompanyBoxLabel, supCompanyList} from "../../../../controller/sys";
import {saveAsnPrintControl, deleteAsnPrintControl, getAsnPrintControl, updateAsnPrintControl} from "../../../../controller/sap";
import { getAllPurchaseTypes, formatForSelect } from '@/utils/purchaseTypeCache';

export default {
  name:'DeliveryPrintingSettingIndex',
  data(){
    return{
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataList: [],
      purchaseTypeOptions: [], // 订单类型下拉选项
      // 搜索条件
      searchForm: {
        searchOrgCode: '',
        searchOrgName: '',
        searchOrderType: ''
      },
      // 新增/修改对话框相关
      dialogVisible: false,
      dialogMode: 'add', // 'add' | 'edit'
      existingLogoPreview: null, // 编辑时现有LOGO预览(data:image/png;base64,...)
      addForm: {
        id: '', // 修改时使用
        subcompany: {
          id: '',
          code: '',
          name: ''
        },
        subcompanyId: '', // 专门存储子公司ID
        subcompanyCode: '', // 专门存储子公司代码
        paperOri: 0, // 模板类型，默认A4-器具
        orderType: '', // 订单类型，空字符串表示默认配置
        logoPng: null // 公司LOGO
      },
      addRules: {
        'subcompany.name': [{ required: true, message: '请选择子公司', trigger: 'change' }],
        paperOri: [{ required: true, message: '请选择模板类型', trigger: 'change' }],
      },
      // 子公司搜索帮助相关
      subcompanyDialogVisible: false,
      subcompanyFilter: '',
      subcompanies: [], // 实际应从接口获取
      selectedSubcompany: null,
      // 文件上传相关
      fileList: [],
      maxFileSize: 2 * 1024 * 1024,
      rules: {
        logoPng: [{
          required: true,
          validator: (rule, value, callback) => {
            const row = this.dataList.find(item => item.printId === rule.boxId)
            if (row?.printFlag === '1' && !value) {
              callback(new Error('当选择打印时公司标识必填'))
            } else {
              callback()
            }
          }
        }]
      }
    }
  },
  activated() {
    this.getDataList()
    // 加载订单类型下拉选项
    if (this.purchaseTypeOptions.length === 0) {
      getAllPurchaseTypes().then(list => {
        this.purchaseTypeOptions = formatForSelect(list);
      });
    }
  },
  computed: {
    tableHeight: {
      get() {
        return this.$store.state.common.documentClientHeight - 410
      }
    },
    filteredSubcompanies() {
      if (!this.subcompanyFilter) {
        return this.subcompanies;
      }
      return this.subcompanies.filter(item =>
          item.orgCode.includes(this.subcompanyFilter) ||
          item.orgName.includes(this.subcompanyFilter)
      );
    }
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      getAsnPrintControl(this.searchForm).then(data => {
        if (data && data.code === '00') {
          this.dataList = data.body.map(item => ({
            ...item,
            paperOri: item.paperOri || 0, // 默认值处理
            logoPng: item.logoPng || null
          }))
          this.totalPage = data.body.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      }).catch((e) => {
      }).finally(() => {
        this.dataListLoading = false
      })
    },
    byteArrayToBase64(byteArray) {
      if (!byteArray) return null;

      // 将byte数组转换为base64
      const binaryString = String.fromCharCode.apply(null, byteArray);
      const base64String = btoa(binaryString);
      return base64String;
    },
    // 在methods中定义
    // 查看LOGO
    viewLogo(base64Data) {
      if (!base64Data) {
        this.$message.warning('没有可显示的LOGO');
        return;
      }

      // 确保 base64Data 是纯 Base64 字符串，不包含 data:image 前缀
      let pureBase64 = base64Data;
      if (base64Data.startsWith('data:image')) {
        pureBase64 = base64Data.split(',')[1];
      }

      // 创建一个临时的img元素来显示图片
      const img = new Image();
      img.src = `data:image/png;base64,${pureBase64}`;
      img.style.maxWidth = '300px';
      img.style.maxHeight = '200px';

      // 显示图片
      this.$alert(`<img src="${img.src}" style="max-width: 300px; max-height: 200px;">`, '公司LOGO', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'info'
      });
    },
    // 新增按钮点击事件
    handleAdd() {
      this.dialogMode = 'add';
      this.existingLogoPreview = null;
      this._logoCleared = false;
      // 初始化表单
      this.addForm = {
        id: '',
        subcompany: {
          id: '',
          code: '',
          name: ''
        },
        subcompanyId: '',
        subcompanyCode: '',
        paperOri: 0,
        orderType: '',
        logoPng: null
      };
      this.dialogVisible = true;
      this.fileList = [];
      this.selectedSubcompany = null;
      this.$nextTick(() => {
        if (this.$refs.addForm) {
          this.$refs.addForm.clearValidate();
        }
      });
    },

    // 修改按钮点击事件
    handleEdit(row) {
      this.dialogMode = 'edit';
      this._logoCleared = false;
      // 预填现有数据
      this.addForm = {
        id: row.id,
        subcompany: {
          id: row.subcompanyId,
          code: row.orgCode,
          name: row.orgName
        },
        subcompanyId: row.subcompanyId,
        subcompanyCode: row.orgCode,
        paperOri: row.paperOri || 0,
        orderType: row.orderType || '',
        logoPng: null  // 未选新文件则保留现有
      };
      // 显示现有LOGO预览
      this.existingLogoPreview = row.logoPng ? `data:image/png;base64,${row.logoPng}` : null;
      this.fileList = [];
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.addForm) {
          this.$refs.addForm.clearValidate();
        }
      });
    },

    // 加载子公司数据
    loadSubcompanies() {
      supCompanyList().then(response => {
        if (response && response.code === '00') {
          this.subcompanies = response.body.map(item => ({
            id: item.id,
            orgCode: item.orgCode,
            orgName: item.orgName
          }));
        }
      }).catch(error => {
        this.$message.error('加载子公司数据失败');
        console.error(error);
      });
    },
    // 打开子公司搜索帮助
    openSubcompanyDialog() {
      this.subcompanyDialogVisible = true;
      this.selectedSubcompany = null;
      // 加载子公司数据
      this.loadSubcompanies();
    },

    // 选择子公司
    handleSubcompanySelect(row) {
      this.selectedSubcompany = row;
    },

    // 确认子公司选择
    confirmSubcompany() {
      if (!this.selectedSubcompany) {
        this.$message.warning('请选择子公司');
        return;
      }

      this.addForm.subcompany = {
        id: this.selectedSubcompany.id,
        code: this.selectedSubcompany.orgCode,
        name: this.selectedSubcompany.orgName
      };

      // 保存subcompany id和orgCode用于后续操作
      this.addForm.subcompanyId = this.selectedSubcompany.id;
      this.addForm.subcompanyCode = this.selectedSubcompany.orgCode;

      this.subcompanyDialogVisible = false;
    },

    // 文件上传相关方法
// 删除 beforeUpload 方法，修改 handleFileChange
    handleFileChange(file, fileList) {
      if (file.size > this.maxFileSize) {
        this.$message.error(`文件大小不能超过 ${this.maxFileSize/(1024 * 1024)}MB`);
        this.fileList = [];
        return;
      }
      this.fileList = fileList;

      // 关键：检查文件是否有 raw 属性（element-ui 的文件对象）
      if (file.raw) {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const arrayBuffer = e.target.result;
            const byteArray = new Uint8Array(arrayBuffer);

            if (byteArray && byteArray.length > 0) {
              this.addForm.logoPng = byteArray;

              // 计算Base64大小进行预检查 (2MB文件转Base64约为2.67MB)
              const tempBase64 = btoa(String.fromCharCode.apply(null, byteArray));
              // Base64字符串最大限制设为 3MB (考虑到Base64会比原文件大约33%)
              if (tempBase64.length > 3 * 1024 * 1024) {
                this.$message.warning('文件转换后过大，请选择更小的图片');
                this.addForm.logoPng = null;
                this.fileList = [];
              }
            } else {
              console.error('字节数组为空');
              this.$message.error('文件读取失败：数据为空');
            }
          } catch (error) {
            console.error('文件读取错误:', error);
            this.$message.error('文件读取失败');
          }
        };
        reader.onerror = () => {
          console.error('FileReader 错误');
          this.$message.error('文件读取失败');
        };
        reader.readAsArrayBuffer(file.raw);
      }
    },

    handleExceed(file, fileList) {
      this.$message.warning('最多只能上传一个文件');
    },

    handleRemove(file, fileList) {
      // 处理文件删除
      this.fileList = fileList;
      this.addForm.logoPng = null;
      this._logoCleared = false; // 取消清除标记，保留现有LOGO
      console.log('文件已移除，logoPng 设置为 null');
    },

    // 修改 beforeUpload 方法
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        const isImage = file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg';
        if (!isImage) {
          this.$message.error('只能上传PNG/JPG/JPEG格式文件');
          reject(false);
          return;
        }
        const isLessThan2M = file.size / 1024 / 1024 < 2;
        if (!isLessThan2M) {
          this.$message.error('上传文件大小不能超过 2MB!');
          reject(false);
          return;
        }

        // 将文件转换为字节数组
        const reader = new FileReader();
        reader.onload = (e) => {
          const arrayBuffer = e.target.result;
          const byteArray = new Uint8Array(arrayBuffer);

          // 确认字段类型正确
          this.addForm.logoPng = byteArray;

          // 同时更新 fileList 中的文件状态
          if (this.fileList.length > 0) {
            this.fileList[0].status = 'success';
          }

          resolve(true);
        };
        reader.onerror = () => {
          this.$message.error('文件读取失败');
          reject(false);
        };
        reader.readAsArrayBuffer(file);
      });
    },



    handleSuccess(response, file, fileList) {
      // 文件上传成功后处理
      this.addForm.logoPng = file.name;
    },

    handleError(err, file, fileList) {
      // 文件上传失败处理
      this.$message.error('文件上传失败，请重试');
    },

    // 保存新增/修改
    saveAdd() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          // 额外验证子公司是否已选择
          if (!this.addForm.subcompany.id) {
            this.$message.warning('请选择子公司');
            return;
          }
          // 新增模式必须选LOGO，修改模式可选
          if (this.dialogMode === 'add' && (!this.addForm.logoPng || this.addForm.logoPng.length === 0)) {
            this.$message.warning('请先选择有效的LOGO文件');
            return;
          }

          // LOGO处理：null=保留现有，空字符串=清除
          let base64Logo = null;
          if (this._logoCleared) {
            base64Logo = ''; // 空字符串表示清除LOGO
          } else if (this.addForm.logoPng) {
            base64Logo = this.byteArrayToBase64(this.addForm.logoPng);
            // 检查Base64字符串长度是否过大
            if (base64Logo && base64Logo.length > 2 * 1024 * 1024) {
              this.$message.warning('LOGO文件过大，请选择小于2MB的图片');
              return;
            }
          }

          // 构建请求参数
          const payload = {
            subcompanyId: this.addForm.subcompanyId,
            paperOri: this.addForm.paperOri,
            orderType: this.addForm.orderType || null, // 空字符串传 null 表示默认配置
            logoPng: base64Logo
          };

          let apiCall;
          let successMsg;
          if (this.dialogMode === 'edit') {
            payload.id = this.addForm.id;
            apiCall = updateAsnPrintControl(payload);
            successMsg = '修改成功';
          } else {
            apiCall = saveAsnPrintControl(payload);
            successMsg = '保存成功';
          }

          apiCall.then((res) => {
            if (res && res.code === '00') {
              this.$message.success(successMsg);
              this.dialogVisible = false;
              this.getDataList();
              this.resetAddForm();
            } else {
              this.$message.error(res.msg || (this.dialogMode === 'edit' ? '修改失败' : '保存失败'));
            }
          }).catch(error => {
            console.error('保存失败:', error);
            this.$message.error('保存失败');
          });
        } else {
          this.$message.warning('请完善必填信息');
        }
      });
    },
// 重置新增表单
    resetAddForm() {
      this.dialogMode = 'add';
      this.existingLogoPreview = null;
      this.addForm = {
        id: '',
        subcompany: {
          id: '',
          code: '',
          name: ''
        },
        subcompanyId: '',
        subcompanyCode: '',
        paperOri: 0,
        orderType: '',
        logoPng: null
      };
      this.fileList = [];
      this.selectedSubcompany = null;

      // 清除表单验证
      if (this.$refs.addForm) {
        this.$refs.addForm.clearValidate();
      }
    },

    // 删除现有LOGO（仅编辑模式）
    removeExistingLogo() {
      this.existingLogoPreview = null;
      // 将 logoPng 设为特殊值以标记需要清除（与 null 区分，null 表示保留现有）
      this._logoCleared = true;
      this.fileList = [];
      this.addForm.logoPng = null;
    },

    // 删除行
    handleDelete(row) {
      this.$confirm('确认删除该条记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAsnPrintControl( {id: row.id}).then((res) => {
          if (res && res.code === '00') {
            this.getDataList()
            this.$message.success('删除成功')
          } else {
            this.$message.error('删除失败')
          }
        })
      }).catch(() => {
        // 用户取消删除
      });
    }
  }
}
</script>

<style lang="scss">
.required-print.el-input-inner {
  border-left: 3px solid #f56c6c
}
</style>
